import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConsentDialogComponent, ConsentDialogData } from '@components/shared/consent-dialog/consent-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConsentDialogService {
  
  private dialog = inject(MatDialog);
  
  /**
   * Opens a consent dialog with the specified consent request ID
   * @param consentRequestId The consent request ID to process
   * @param title Optional title for the dialog
   * @returns Observable that emits the dialog result
   */
  openConsentDialog(
    consentRequestId: string, 
    title?: string
  ): MatDialogRef<ConsentDialogComponent> {
    
    const dialogData: ConsentDialogData = {
      consentRequestId,
      title
    };
    
    return this.dialog.open(ConsentDialogComponent, {
      data: dialogData,
      width: '90vw',
      maxWidth: '600px',
      height: '85vh',
      maxHeight: '600px',
      disableClose: true, // Prevent closing by clicking outside
      autoFocus: false, // Prevent auto-focus for better UX
      panelClass: 'consent-dialog-panel'
    });
  }
  
  /**
   * Quick method to open consent dialog and return a promise
   * @param consentRequestId The consent request ID to process
   * @param title Optional title for the dialog
   * @returns Promise that resolves with the dialog result
   */
  async openConsentDialogAsync(
    consentRequestId: string, 
    title?: string
  ): Promise<any> {
    const dialogRef = this.openConsentDialog(consentRequestId, title);
    return dialogRef.afterClosed().toPromise();
  }
}
